import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = () => ({
    background: '#F6F7FF',
    padding: '1.75rem',
    paddingLeft: '1.5rem',
    display: 'flex',
    gap: '1.25rem',
});

export const title: TRuleWithTheme = ({ theme }) => ({
    fontFamily: theme.fonts.heroNewBold,
    fontWeight: '700',
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
});

export const icon: TRuleWithTheme = ({ theme }) => ({
    fontFamily: theme.fonts.heroNewMedium,
    fontSize: '1.75rem',
    lineHeight: '2.275rem',
});
